import * as globals from '../training/globals';

export enum Status {
  Unassigned = globals.UNASSIGNED,
  Assigned = globals.ASSIGNED,
  Assigning = globals.ASSIGNING,
  Creating = globals.CREATING,
  InUse = globals.IN_USE,
  Error = globals.ERROR,
  Cleaning = globals.CLEANING,
  ErrorAssign = globals.ERROR_ASSIGN,
  Streaming = globals.STREAMING,
  On = globals.ON,
  Off = globals.OFF,
}
